import { BinaryFunction } from "../../../math/BinaryFunction";
import { MathX } from "../../../math/MathX";
import { WaveFormBlockReader } from "./WaveFormBlockReader";
import { WaveLevelData } from "./WaveLevelData";

export class WaveLevels
{
  _numSamples:number = 0;
  _positionToNormalized = 1;
  _min:number = 0;
  _max:number = 0;
  _levels:WaveLevelData[] = [];

  static readonly max:BinaryFunction = ( a, b ) => Math.max( a, b );
  static readonly min:BinaryFunction = ( a, b ) => Math.min( a, b );


  constructor( min:number, max:number, numSamples:number)
  {
    this._numSamples = numSamples;
    this._positionToNormalized = 1 / numSamples;
    this._min = min;
    this._max = max;

    this._createLevelData();
  }

  private _createLevelData()
  { 
    for ( let i = this._min; i <= this._max; i++ )
    {
      let levelDivision  = WaveLevels.getLevelDivision( i );
      let floatSamples  = this._numSamples / levelDivision; 
      let samplesRounded = Math.ceil( floatSamples );
      
      let data = new WaveLevelData( samplesRounded, floatSamples );

      this._levels.push( data );

    }
  } 

  static getLevelDivision( levelIndex:number )
  {
    if ( levelIndex == 0 )
    {
      return 1;
    }

    return Math.pow( 2, levelIndex );
  }

  static resolutionToLevelIndex( resolution:number )
  {
    return MathX.exponent( 2, resolution ); 
  }

  getLevelIndex( levelNumber:number )
  {
    let availableLevel = MathX.clamp( levelNumber, this._min, this._max );
    let flooredLevel   = Math.floor( availableLevel );
    return flooredLevel - this._min;
  }

  get( levelNumber:number )
  {
    return this._levels[ this.getLevelIndex( levelNumber ) ];
  } 

  getLevelLerpAmount( levelNumber:number )
  {
    let availableLevel  = MathX.clamp( levelNumber, this._min, this._max );
    let flooredLevel    = Math.floor( availableLevel );
    let levelLerpAmount = availableLevel - flooredLevel;

    return levelLerpAmount;
  }

  setData( reader:WaveFormBlockReader, offset:number )
  {
    for ( let i = this._min; i <= this._max; i++ )
    {
      let level = this.get( i );
      let data  = reader.get( i );

      let division = WaveLevels.getLevelDivision( i );

      let levelOffset = offset / division;

      if ( i === 1 )
      {
        console.log( "set level", i, "at", levelOffset, "(/" + division +")", `lengths: level|reader: ${level._data.length}|${data.length}` );
      }
      
      let offsetEnd = Math.min( data.length, level._data.length - levelOffset );

      let infoFrequency = Math.round( offsetEnd / 10 );
      
      for ( let j = 0; j < offsetEnd; j++ )
      {
        var sample =  MathX.clamp( data[ j ] * 127, -127, 127 );
        var index = levelOffset + j;

        level._data[ index ] = Math.round( sample );

        if ( i == 1 && j % infoFrequency === 0 )
        {
          console.log( "set ", `[${i}][${index}] = ${sample}`, " in data:", level._data[ index ] );
        }

        
      }

    }
  }
}